import React, { useEffect, useState } from "react"
import AniLink from "gatsby-plugin-transition-link/AniLink"

import "./header.css"
import Logo from '../../assets/svg/logo.svg';
import IconTelephone from '../../assets/svg/icon-telephone.svg';
import IconEnvelope from '../../assets/svg/icon-envelope.svg';

import MobileNav from '../mobile-nav/mobile-nav';

const Header = ({ isMenuActive, setMenuActive }) => {
  useEffect(() => {
    window.addEventListener('scroll', scrollFnc)

    return () => {
      window.removeEventListener('scroll', scrollFnc)
    }
  })

  let previousScroll

  if (typeof window !== 'undefined') {
    // eslint-disable-next-line compat/compat
    previousScroll = window.scrollY || window.pageYOffset
  }

  const [isFixed, setFixed] = useState(false)
  const [isHidden, setHidden] = useState(false)

  const scrollFnc = () => {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line compat/compat
      const scrollY = window.scrollY || window.pageYOffset

      const headerHeight = 100

      setFixed(scrollY > headerHeight)
      setHidden(scrollY > headerHeight && previousScroll < scrollY)

      previousScroll = scrollY
    }
  }

  return (
    <header>
      <div className={`hd-Header${isFixed ? ' hd-Header-scrolled' : ''}${isHidden ? ' hd-Header-hidden' : ''}`}>
        <div className="hd-Header_Inner lyt-Container">
          <div className="hd-Header_Body">
            <div className="hd-Header_Side hd-Header_Side-contact">
              <ul className="hd-Header_Items">
                <li className="hd-Header_Item">
                  <a className="hd-Header_Link hd-Header_Link-icon" href="tel:01438316400" target="_blank" rel="noopener noreferrer">
                    <IconTelephone />

                    <span className="hd-Header_LinkText">01438 316 400</span>
                  </a>
                </li>

                <li className="hd-Header_Item">
                  <a className="hd-Header_Link hd-Header_Link-icon" href="mailto:info@cbwlimited.com" target="_blank" rel="noopener noreferrer">
                    <IconEnvelope />

                    <span className="hd-Header_LinkText">info@cbwlimited.com</span>
                  </a>
                </li>
              </ul>
            </div>

            <div className="hd-Header_Logo">
              <AniLink
                cover
                bg="#22242b"
                direction="up"
                to="/"
                className="hd-Header_LogoLink"
              >
                <Logo />
              </AniLink>
            </div>

            <div className="hd-Header_Side hd-Header_Side-links">
              <button
                type="button"
                className="hd-Header_NavButton"
                onClick={() => {
                  setMenuActive(!isMenuActive)
                }}>
                  <div className="hd-Header_NavBars"></div>
              </button>

              <ul className="hd-Header_Items hd-Header_Items-nav">
                <li className="hd-Header_Item">
                  <AniLink
                    cover
                    bg="#22242b"
                    direction="up"
                    to="/services"
                    className="hd-Header_Link"
                  >
                    <span className="hd-Header_LinkText">Services</span>
                  </AniLink>
                </li>

                <li className="hd-Header_Item">
                  <AniLink
                    cover
                    bg="#22242b"
                    direction="up"
                    to="/process"
                    className="hd-Header_Link"
                  >
                    <span className="hd-Header_LinkText">Process</span>
                  </AniLink>
                </li>

                <li className="hd-Header_Item">
                  <AniLink
                    cover
                    bg="#22242b"
                    direction="up"
                    to="/contact"
                    className="hd-Header_Link"
                  >
                    <span className="hd-Header_LinkText">Contact</span>
                  </AniLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <MobileNav />
    </header>
  )
}

export default Header
